export class ExaFormControl {
    stato: ExaControlStato=ExaControlStato.ok;
  }


export enum ExaControlStato {
	ok = 0,
	wait = 1,
	error = 2
}
  


// WEBPACK FOOTER //
// ./src/app/exa/exa-form-control.ts